import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link, NavLink } from 'react-router-dom'
import * as Icons from 'react-feather'

import {
	getModel,
	setAuthToken,
	setInitialModel,
	updateModel,
} from '../data/Model'
import { selectClient, getSelectedClients } from '../data/interactions'

class Navigation extends Component {
	render() {
		const Model = getModel()
		return (
			<nav className='noselect'>
				<ul>
					<li>
						<NavLink to='/seshat-lookup'>Seshat Lookup</NavLink>
					</li>
					<li>
						<NavLink to='/filter-settings'>Filter settings</NavLink>
					</li>
					<li>
						<NavLink to='/registration-certificates'>
							Registration Certificates
						</NavLink>
					</li>
					<li>
						<NavLink to='/pricing'>Pricing</NavLink>
					</li>
					<li>
						<NavLink to='/screenshot-review'>Screenshot Review</NavLink>
					</li>
					<li
						onClick={() => {
							updateModel((model) => {
								model.dropdownOpen = !model.dropdownOpen
								return model
							})
						}}
						className='dropdown'
					>
						<Icons.User
							style={{
								position: 'absolute',
								top: '16px',
								left: '15px',
								height: '25px',
								width: '25px',
							}}
						/>
						<span
							style={{
								paddingLeft: '30px',
								paddingRight: '20px',
								whiteSpace: 'nowrap',
								overflow: 'hidden',
								textOverflow: 'ellipsis',
							}}
						>
							{getSelectedClients() &&
								getSelectedClients()
									.map((client) => client.name)
									.join(', ')}
							{getSelectedClients().length === 0 && <code>Select client</code>}
							<span className='name'>
								{Model.me.data.firstname} {Model.me.data.lastname}
							</span>
							{Model.dropdownOpen && <span className='dropdown-layer' />}
						</span>
						<Icons.ArrowDown
							style={{
								position: 'absolute',
								top: '20px',
								right: '10px',
								height: '20px',
								width: '20px',
							}}
						/>
						{Model.dropdownOpen && (
							<div>
								<div
									className='item'
									onClick={() => {
										setAuthToken('')
										setInitialModel()
									}}
									style={{
										padding: '9px 15px',
									}}
								>
									{this.context.gettext('admin.logout')}
								</div>
								<div className='header'>Clients</div>
								{Model.me.data.clients.length > 0
									? Model.me.data.clients.map((client, i) => (
											<div
												onClick={() => {
													selectClient(client.client_id)
													updateModel((model) => {
														model.dropdownOpen = false
														return model
													})
												}}
												key={client.client_id}
												className={client.active ? 'item active' : 'item'}
												style={
													i === 0
														? {
																borderTop: '1px solid #ddd',
															}
														: {}
												}
											>
												{client.name}
											</div>
										))
									: ''}
								<div
									className='item'
									style={{
										padding: '7px 15px',
									}}
								>
									<Link to='/add-partner'>+ Add Partner</Link>
								</div>
							</div>
						)}
					</li>
				</ul>
			</nav>
		)
	}
}

Navigation.contextTypes = {
	gettext: PropTypes.func.isRequired,
}

export default Navigation
